<ng-template #rvwMain>
  <div class="reviewmain" [ngClass]="{'reviewmain2': other_content}" *ngFor="let review of reviewData?.reviews || []">
    <div class="tophead">
      <span> {{review.rating | number:'1.0-0'}} <img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/star-yellow.svg'" [alt]="review.title"> </span>
      <h4 class="mb-0">{{review.title}}</h4>
    </div>
    <p>{{review.description}}.</p>
    <div class="bottom-text"><span class="date">{{review.reviewDate | date: 'fullDate'}}</span> <span
        class="name">{{review.reviewerName}}</span></div>
  </div>
  <div *ngIf="reviewData && (!reviewData.reviews || (!reviewData.reviews.length))" class="pt-5 img-main text-center">
    <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/saved-items/saved-product-img.svg'" alt="No Reviews Yet | Luminous">
    <p class="text-center pt-3">No Review(s) Yet</p>
  </div>
</ng-template>
<ng-template #rvwSummary>
  <ul>
    <li *ngFor=" let attribute of reviewData?.overAll || []">
      <p>{{attribute.name}}</p>
      <span> {{attribute.rating | number:'1.0-0'}} <img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/star-yellow.svg'" [alt]="attribute.name"> </span>
    </li>
  </ul>
</ng-template>

<div class="allreview-wrap" *ngIf="activeRoute.includes('all-reviews'); else other_content">
  <div class="main-content"></div>
  <div class="container">

    <div class="allreview-row pb-5 mb-md-5">
      <div class="allreview">
        <h1><img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/back-icon.svg'" alt="Back Arrow | Luminous" (click)="routeToProduct()"> All Reviews </h1>
        <ng-container *ngTemplateOutlet="rvwMain"></ng-container>

      </div>
      <div class="ordersummary">
        <h2><img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/back-icon.svg'" alt="Back Arrow | Luminous"> All Reviews </h2>
        <h1>Review Summary</h1>
        <ng-container *ngTemplateOutlet="rvwSummary"></ng-container>

        <a (click)="openReviewDialog()" class="primaryBtn">
          <!-- <img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/star-white.svg'" alt="Star Rating | Luminous"> -->
          <svg xmlns="http://www.w3.org/2000/svg" class="me-2 mb-1" width="20" height="18" viewBox="0 0 576 512">
            <path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" fill="#ffffff"/>
          </svg>
          Write aReview</a>
      </div>
    </div>

  </div>
</div>




<ng-template #other_content>
  <div class="container allreview-wrap rvw2">
    <div class="allreview-row">
      <div class="ordersummary pe-5 ps-0 pt-5 ">
        <h2><img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/back-icon.svg'" alt="All Reviews | Luminous"> All Reviews </h2>
        <h3>What our customers say</h3>
        <ng-container *ngTemplateOutlet="rvwSummary"></ng-container>
        <a class="grey-btn" (click)="openReviewDialog()"><img class="me-3"
           loading="lazy" [src]="environment?.blobUrl+'/assets/images/inbt-seriespage/star.svg'" alt="Review | Luminous">Write a
          Review</a>
      </div>
      <div class="allreview d-flex flex-column align-items-center pt-5 ">
        <ng-container *ngTemplateOutlet="rvwMain"></ng-container>
        <div *ngIf=" reviewData && reviewData.reviews && reviewData.reviews.length"
          class="read-all-reviews text-start w-100"><a [routerLink]="['/all-reviews', this.pageName]"
            class=" font-bold d-lg-inline-block">Read all reviews
            <img class="ms-3"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/arrow-right.svg'" alt="ArrowRight | Luminous">
          </a></div>
      </div>
    </div>
  </div>
</ng-template>
